import React from "react";
import { ExternalLink } from "lucide-react";
import { Sparkle, StickerNote } from "../components/Decor2";
import { WavyBreak, FramedImage } from "../components/Wavy";
import { useSection } from "../context/SiteContext";

const BloomClub = () => {
  const { data: bc } = useSection("bloom_club");
  const link = bc.link || "https://heritagebloomclub.nz";

  return (
    <div className="bg-cream">
      <section className="relative pt-12 md:pt-20 pb-14 px-6 md:px-10 overflow-hidden">
        <Sparkle className="absolute top-16 left-14 w-6 h-6" color="#FF7A3D" />
        <Sparkle className="absolute top-28 right-24 w-5 h-5" color="#EC2675" />

        <div className="max-w-[1100px] mx-auto grid md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-5 max-w-[380px] mx-auto w-full">
            <FramedImage src={bc.image} alt="Heritage Bloom Club" bg="#FF7A3D" contain testid="bloom-club-image" />
          </div>
          <div className="md:col-span-7 text-center md:text-left">
            <span className="font-serif-display uppercase tracking-[0.3em] text-orange text-[11px] md:text-sm font-semibold">FLOWERS, DELIVERED WITH JOY</span>
            <h1 className="font-serif-display uppercase text-plum-deep text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[0.95]" data-testid="bloom-club-title">
              {bc.title || "HERITAGE BLOOM CLUB"}
            </h1>
            <p className="mt-6 text-plum-deep/80 text-base md:text-lg max-w-xl mx-auto md:mx-0" data-testid="bloom-club-intro">
              {bc.intro}
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-5 justify-center md:justify-start">
              <a
                href={link.startsWith("http") ? link : `https://${link}`}
                target="_blank"
                rel="noreferrer"
                data-testid="bloom-club-link"
                className="inline-flex items-center gap-3 rounded-full bg-orange text-cream px-8 py-4 font-serif-display uppercase text-sm tracking-[0.18em] font-semibold hover:bg-magenta transition-colors ring-2 ring-offset-4 ring-offset-cream ring-orange/40"
              >
                {bc.cta_label || "VISIT HERITAGE BLOOM CLUB"} <ExternalLink className="w-4 h-4" />
              </a>
              <StickerNote rotate={-6} color="#FF7A3D" size="text-2xl md:text-3xl">reusable ♻</StickerNote>
            </div>
          </div>
        </div>
      </section>

      <WavyBreak color="#FF7A3D" />
    </div>
  );
};

export default BloomClub;
